// Unpublished Work © 2025 Deere & Company.

import {fetchWrapper} from './utils/fetch-wrapper';

export const createUserSession = (userId, applicationName) => {
    const payload = {
        userId,
        applicationName
    };

    fetchWrapper('/api/userSession', {
        body: JSON.stringify(payload),
        method: 'POST'
    });
};
